<div class="dropdown">
    <!-- Dropdown toggle -->
    <div class="c-dropdown-toggle" data-bs-toggle="dropdown">
        <img src="assets/icons/calendar-with-dollar-icon-white.svg" />
    </div>

    <!-- Dropdown menu -->
    <div class="dropdown-menu">
        <!-- <img class="pointer" src="assets/icons/triangle.svg" /> -->
        <div class="menu-container">
            <div class="heading">
                <img src="assets/icons/calendar-with-dollar-icon-blue.svg" />
                <span class="heading-label"><ng-container i18n="@@accountingPeriod">Accounting Period</ng-container>:</span>
                <span class="heading-value">{{ activePeriod.dateStart | date : 'MMMM' }} {{ activePeriod.fiscalYear }}</span>
            </div>
            <div class="content">
                <div class="content-item">
                    <div class="label"><ng-container i18n="@@openPeriods">Open Periods</ng-container>:</div>
                    <div class="value">{{ openPeriod.startDate | date : 'MMM y' }} - {{ openPeriod.endDate | date : 'MMM y' }}</div>
                </div>
                <div class="content-item">
                    <div class="label"><ng-container i18n="@@gracePeriod">Grace Period</ng-container>:</div>
                    <div class="value">{{ openPeriod.gracePeriodDate | date : 'longDate' }}</div>
                </div>
            </div>
        </div>
        
    </div>
</div>